import { lazy } from "react";
// MANTENIMIENTO (temporal): con WELCOME_OEP_MAINTENANCE en true la ruta sirve
// la página de aviso en vez del módulo. Ambas páginas van por lazy para que
// la que no se usa no viaje en el bundle. Detalle del flag en common/constants.
import { WELCOME_OEP_MAINTENANCE } from "./common/constants";

const WelcomeOepPage = lazy(() => import("./pages/WelcomeOepPage"));
const WelcomeOepMaintenancePage = lazy(() => import("./pages/WelcomeOepMaintenancePage"));

export const welcomeOepRoutes = [
  {
    path: "/welcome-oep",
    element: WELCOME_OEP_MAINTENANCE ? <WelcomeOepMaintenancePage /> : <WelcomeOepPage />,
  },
];
